import { awxOrganizationStateAtom } from "@common/state/organizationState";
import { BankAccountOnboardingState } from "./AdminBankAccountOnboardingState";
import { useRecoilValue } from "recoil";

export const AdminBankAccountTab = () => {
  const awxOrganizationState = useRecoilValue(awxOrganizationStateAtom);

  return (
    <BankAccountOnboardingState organizationStateData={awxOrganizationState} />
  );
};
